// extracted by mini-css-extract-plugin
export default {"myTabs":"tabs_myTabs__4GLKb","badge":"tabs_badge__VUeJ0","badge-yellow":"tabs_badge-yellow__-wezh","badge-green":"tabs_badge-green__A62m0","badge-red":"tabs_badge-red__idBzR"};